import React, { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { createPortal } from "react-dom"; // For portal usage
import { fetchUserData } from "api/auth"; // Import your actual fetch function
import { useGlobalContext } from "context/GlobalContext";
import { SyncLoader } from "react-spinners";
import RouteLoader from "../RouteLoader";

const ProtectedRoute = ({ children }) => {
	const { currentDomain, setCurrentDomain, setNotifications } =
		useGlobalContext();
	const [isAuthenticated, setIsAuthenticated] = useState(null); // Set initial state to null
	const [loading, setLoading] = useState(true); // Track loading state
	const location = useLocation();
	const navigate = useNavigate();
	const queryParams = new URLSearchParams(location.search);
	const token = queryParams.get("token");

	useEffect(() => {
		const token = queryParams.get("token");

		if (token) {
			localStorage.setItem("token", token);

			try {
				fetchUserData(token).then((response) => {
					if (response) {
						localStorage.setItem("user", JSON.stringify(response.data));
						setIsAuthenticated(true);
						setNotifications(response.data.notifications);
						if (response.domainAccessCheck) {
							setCurrentDomain(response.data.current_domain);
						} else {
							let appCurrentDomain = response.data.current_domain;
							appCurrentDomain.name = "app";
							setCurrentDomain(appCurrentDomain);
						}

						// Clean URL after storing user and token
						navigate(location.pathname, { replace: true });
					} else {
						setIsAuthenticated(false);
					}
					setLoading(false);
				});
			} catch (error) {
				console.error("Error in authentication:", error);
				setIsAuthenticated(false);
				setLoading(false);
			}
		} else {
			// Check local storage if URL params are missing
			const storedToken = localStorage.getItem("token");
			if (storedToken) {
				setIsAuthenticated(true);
				setLoading(false);
				return; // Skip further processing if token exists in localStorage
			}
			setIsAuthenticated(false);
			setLoading(false);
		}
	}, [token, location.pathname, navigate]);

	// Loader UI component for displaying full-screen spinner
	const Loader = () => (
		<div
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				width: "100%",
				height: "100%",
				backgroundColor: "rgba(0,0,0,0.5)",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				zIndex: 9999,
			}}
		>
			<div
				style={{
					fontSize: "1.5em",
					color: "white",
					zIndex: 10000,
				}}
			>
				<SyncLoader color="#fff" loading={true} />
			</div>
		</div>
	);

	// Render loading spinner if the authentication check is still in progress
	if (loading) {
		return createPortal(<Loader />, document.body); // Use portal to ensure it's rendered in the right DOM tree
	}

	// If not authenticated, redirect to login page
	if (!isAuthenticated && !loading) {
		return <Navigate to="/login" />;
	}

	// Render the protected content if authenticated
	return <RouteLoader>{children}</RouteLoader>;
};

export default ProtectedRoute;
